import React from 'react'
import { Container, Card } from 'react-bootstrap'
import { FaUsers, FaCode, FaClipboardCheck, FaChalkboardTeacher } from 'react-icons/fa'


function OurServicesSection() {
  return (
      <Container className='services-section' style={{ marginTop: '1rem'}}>
        <h2 className='text-center' style={{color: "#F5F5F5"}}>Our Services</h2>
        <div className='services-cards-container' style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '1rem', marginTop: "25px" }}>
          <Card style={{ width: '18rem', textAlign: 'center', backgroundColor: "rgb(2, 21, 43)", color: "#F5F5F5" }}>
            <Card.Body>
              <FaUsers size={50} />
              <Card.Title>Business Solutions</Card.Title>
              <Card.Text>
                Operational expertise to improve financial processes, logistics, and demand planning.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: '18rem', textAlign: 'center', backgroundColor: "rgb(2, 21, 43)", color: "#F5F5F5" }}>
            <Card.Body>
              <FaCode size={50} />
              <Card.Title>Software & Development</Card.Title>
              <Card.Text>
                Bespoke Software to Optimize Your Unique Business Processes.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: '18rem', textAlign: 'center', backgroundColor: "rgb(2, 21, 43)", color: "#F5F5F5" }}>
            <Card.Body>
              <FaClipboardCheck size={50} />
              <Card.Title>Facilities & Compliance</Card.Title>
              <Card.Text>
                Ensuring Your Business is Safe, Compliant, and Ready to Grow.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card style={{ width: '18rem', textAlign: 'center', backgroundColor: "rgb(2, 21, 43)", color: "#F5F5F5" }}>
            <Card.Body>
              <FaChalkboardTeacher size={50} />
              <Card.Title>Training & Support</Card.Title>
              <Card.Text>
                Upskilling Your Workforce with Comprehensive SAP and Business Solutions Training.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </Container>
  )
}

export default OurServicesSection